"use client";

import { trackEvent } from "@/lib/analytics";

export function OpenChatButton() {
  return (
    <button
      type="button"
      onClick={() => {
        trackEvent("chat_open", { chat_source: "open_chat_button" });
        window.dispatchEvent(new CustomEvent("cloudaxe-open-chat"));
      }}
      className="rounded-2xl bg-[#27598e]/90 px-4 py-3 text-sm font-semibold text-white backdrop-blur-sm transition-colors duration-200 hover:bg-[#27598e] dark:bg-white dark:text-black dark:hover:bg-white/90"
    >
      Start chat
    </button>
  );
}
